import { DateTime, Duration } from 'luxon';
import { LocationUpdates } from './location-update';

export class Plan {
  id?: string;
  name?: string;
  description?: string;
  distance?: number;
  duration?: Duration;
  distanceDisplay?: string;
  durationDisplay?: string;
  jobsCount?: number;
  locationsCount?: number;
  planTypeId?: number;
  day?: number;
  planDays?: number[];
  scheduledDays?: number[];
  distributionLaneId?: string;
  distributionLaneName?: string;
  planTypeName?: string;
  units?: string;
  createdAt!: DateTime;
  hasJobFilters?: boolean;
  isPlanRevised?: boolean;
  status?: number;
  isScheduled?: boolean;
  vehiclesCount?: number;
  unplannedLocationsCount?: number;
  plannedLocationsCount?: number;
  locationUpdates?: LocationUpdates[];
  hasLocationUpdates?: boolean;
  scheduleFromDate?: DateTime;
  scheduleToDate?: DateTime;
  executionTime?: string;
  bufferHours?: number;
  planLocationGroupCount?: number;
  planContainerId?: string;
  orgUnitId?: string;
  masterPlanName?: string;
}
